import { render, staticRenderFns } from "./NewCategoryHorizontalListView.vue?vue&type=template&id=1eaa6464&scoped=true&"
import script from "./NewCategoryHorizontalListView.vue?vue&type=script&lang=js&"
export * from "./NewCategoryHorizontalListView.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoryHorizontalListView.vue?vue&type=style&index=0&id=1eaa6464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaa6464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VChip,VCol,VHover,VIcon,VImg,VRow})
